import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import RealExamView from '../views/RealExamView.vue'
import TicketCategoryView from '../views/TicketCategoryView.vue'
import WrongQuestionsView from '../views/WrongQuestionsView.vue'
import MedicalInfoView from '../views/MedicalInfoView.vue'
import RoadSignsView from '../views/RoadSignsView.vue'
import FinesView from '../views/FinesView.vue'
import ResultView from '@/views/ResultView.vue'
import FinesPoints from '@/views/FinesPoints.vue'

const SITE_NAME = 'AvtoTesting.uz'
const SITE_URL = 'https://avtotesting.uz'
const DEFAULT_TITLE = `${SITE_NAME} – Haydovchilik guvohnomasi uchun YHQ testlari`
const DEFAULT_DESCRIPTION =
  'AvtoTesting.uz — haydovchilik guvohnomasi uchun YHQ testlari, real imtihon, biletlar, jarima ballari va foydali tayyorlov materiallari.'
const DEFAULT_IMAGE = `${SITE_URL}/android-chrome-512x512.png`
const DEFAULT_KEYWORDS =
  'avtotesting, avtotest, yhq testlari, haydovchilik guvohnomasi, real imtihon, biletlar, yo‘l belgilari, jarima ballari, avtotesting.uz'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      public: true,
      title: 'Kirish',
      description: 'AvtoTesting.uz tizimiga kirish sahifasi.',
      keywords: 'kirish, login, avtotesting'
    }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Bosh sahifa',
      description:
        'AvtoTesting.uz — haydovchilik guvohnomasi uchun YHQ testlari, real imtihon, test biletlari, jarima ballari va foydali materiallar.',
      keywords:
        'avtotesting, avtotest, bosh sahifa, yhq testlari, haydovchilik testi'
    }
  },
  {
    path: '/real-exam',
    name: 'realExam',
    component: RealExamView,
    meta: {
      title: 'Real imtihon',
      description:
        'Haydovchilik guvohnomasi uchun real imtihon rejimida YHQ testlarini ishlang.',
      keywords:
        'real imtihon, avtotest, yhq imtihon, haydovchilik testi'
    }
  },
  {
    path: '/tickets/:type/:ticketNumber?',
    name: 'ticketCategory',
    component: TicketCategoryView,
    meta: {
      title: 'Biletlar',
      description:
        '10, 20 va 50 talik test biletlari orqali haydovchilik imtihoniga tayyorlaning.',
      keywords:
        'biletlar, 10 talik biletlar, 20 talik biletlar, 50 talik biletlar, yhq testlari'
    }
  },
  {
    path: '/wrong-questions',
    name: 'wrongQuestions',
    component: WrongQuestionsView,
    meta: {
      title: 'Xato belgilagan savollarim',
      description:
        'Oldin xato ishlangan savollarni qayta ko‘rib chiqib, bilimingizni mustahkamlang.',
      keywords:
        'xato savollar, qayta ishlash, avtotest xatolar, yhq savollari'
    }
  },
  {
    path: '/medical-info',
    name: 'medicalInfo',
    component: MedicalInfoView,
    meta: {
      title: 'Tibbiyot ma’lumotlari',
      description:
        'Haydovchilar uchun tibbiyotga oid foydali ma’lumotlar va tushunchalar.',
      keywords:
        'tibbiyot ma’lumotlari, haydovchi tibbiyoti, birinchi yordam'
    }
  },
  {
    path: '/road-signs',
    name: 'roadSigns',
    component: RoadSignsView,
    meta: {
      title: 'Yo‘l belgilari',
      description:
        'Yo‘l belgilari katalogi va ularning ma’nolari bilan tanishing.',
      keywords:
        'yo‘l belgilari, belgilar ma’nosi, yhq belgilar, avtotest belgilar'
    }
  },
  {
    path: '/fines',
    name: 'fines',
    component: FinesView,
    meta: {
      title: 'Jarimalar',
      description:
        'Yo‘l harakati qoidabuzarliklari uchun jarimalar ro‘yxati va tushuntirishlar.',
      keywords:
        'jarimalar, yo‘l jarimalari, qoidabuzarlik, avto jarima'
    }
  },
  {
    path: '/fine-points',
    name: 'fines-points',
    component: FinesPoints,
    meta: {
      title: 'Jarima ballari',
      description:
        'Haydovchilar uchun jarima ballari tizimi haqida ma’lumot.',
      keywords:
        'jarima ballari, ball tizimi, haydovchi ballari'
    }
  },
  {
    path: '/result',
    name: 'result',
    component: ResultView,
    meta: {
      title: 'Natija',
      description:
        'Ishlangan test natijalari, ballar va umumiy ko‘rsatkichlar sahifasi.',
      keywords:
        'natija, test natijasi, avtotest natija, imtihon ballari'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

function setMetaTag(attr, key, content) {
  if (!content) return

  let element = document.head.querySelector(`meta[${attr}="${key}"]`)

  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attr, key)
    document.head.appendChild(element)
  }

  element.setAttribute('content', content)
}

function setCanonical(url) {
  let link = document.head.querySelector('link[rel="canonical"]')

  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }

  link.setAttribute('href', url)
}

function setStructuredData(to) {
  const oldScript = document.getElementById('route-jsonld')
  if (oldScript) oldScript.remove()

  const pageTitle = to.meta?.title
    ? `${to.meta.title} – ${SITE_NAME}`
    : DEFAULT_TITLE

  const pageDescription = to.meta?.description || DEFAULT_DESCRIPTION
  const pageUrl = `${SITE_URL}${to.fullPath}`

  const data = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: SITE_NAME,
        url: SITE_URL
      },
      {
        '@type': 'Organization',
        name: SITE_NAME,
        url: SITE_URL,
        logo: DEFAULT_IMAGE
      },
      {
        '@type': 'WebPage',
        name: pageTitle,
        description: pageDescription,
        url: pageUrl
      }
    ]
  }

  const script = document.createElement('script')
  script.type = 'application/ld+json'
  script.id = 'route-jsonld'
  script.text = JSON.stringify(data)

  document.head.appendChild(script)
}

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('accessToken')
  const isPublicPage = to.meta.public === true

  if (!isPublicPage && !isAuthenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (isAuthenticated && isPublicPage) {
    const redirectPath = to.query.redirect || '/'
    next(redirectPath)
  } else {
    next()
  }
})

router.afterEach((to) => {
  const pageTitle = to.meta?.title
    ? `${to.meta.title} – ${SITE_NAME}`
    : DEFAULT_TITLE

  const pageDescription = to.meta?.description || DEFAULT_DESCRIPTION
  const pageKeywords = to.meta?.keywords || DEFAULT_KEYWORDS
  const pageUrl = `${SITE_URL}${to.fullPath}`

  document.title = pageTitle

  setMetaTag('name', 'description', pageDescription)
  setMetaTag('name', 'keywords', pageKeywords)
  setMetaTag('name', 'robots', 'index, follow, max-image-preview:large')
  setMetaTag('name', 'author', SITE_NAME)
  setMetaTag('name', 'application-name', SITE_NAME)
  setMetaTag('name', 'theme-color', '#ffffff')

  setMetaTag('property', 'og:type', 'website')
  setMetaTag('property', 'og:title', pageTitle)
  setMetaTag('property', 'og:description', pageDescription)
  setMetaTag('property', 'og:url', pageUrl)
  setMetaTag('property', 'og:site_name', SITE_NAME)
  setMetaTag('property', 'og:locale', 'uz_UZ')
  setMetaTag('property', 'og:image', DEFAULT_IMAGE)

  setMetaTag('name', 'twitter:card', 'summary_large_image')
  setMetaTag('name', 'twitter:title', pageTitle)
  setMetaTag('name', 'twitter:description', pageDescription)
  setMetaTag('name', 'twitter:image', DEFAULT_IMAGE)

  setCanonical(pageUrl)
  setStructuredData(to)

  window.scrollTo({ top: 0, behavior: 'smooth' })
})

export default router